module.exports = __webpack_public_path__ + "static/media/arrow-backwards.148c5309.svg";